
import { LicenseInfo } from '@mui/x-license';

const licenseKey = import.meta.env.VITE_MUI_LICENSE_KEY;

if (!licenseKey) {
  console.warn(
    '⚠️ MUI X Pro license key not found in environment variables.\n' +
    'Please add VITE_MUI_LICENSE_KEY to your .env.local file.\n' +
    'Premium features may display watermarks.'
  );
} else {
  LicenseInfo.setLicenseKey(licenseKey);
}

export default LicenseInfo;
